import React from "react";
import { sanitizePolicyHtml } from "../../utils/privacyPolicyApi";

export default function PolicyHtmlContent({ html, className = "" }) {
  const safe = sanitizePolicyHtml(html);
  if (!safe) return null;

  return (
    <div
      className={`policy-html-content ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
